export const OV_FIELDS = {
  OV_GUN_DRILL: 'OV_GUN_GRILL',
  OV_CUT: 'OV_CUT',
  OV_TESTING: 'OV_TESTING',
  OV_DRAW: 'OV_DRAW',
  OV_DRAW_STR_CUT: 'OV_DRAW_STR_CUT',
  OV_STR_CUT: 'OV_STR_CUT',
  OV_GRIND: 'OV_GRIND',
  OV_ULTRASONIC_TESTING: 'OV_ULTRASONIC_TESTING',
  OV_SURFACE_GRIND: 'OV_SURFACE_GRIND',
  OV_LAP: 'OV_LAP',
  OV_STRAIGHTEN: 'OV_STRAIGHTEN',
  OV_PASSIVATE: 'OV_PASSIVATE',
  OV_PLATE: 'OV_PLATE',
  OV_CLEAN: 'OV_CLEAN',
  OV_CRYOGENIC: 'OV_CRYOGENIC',
  OV_TURN: 'OV_TURN',
  OV_HEAT_TREAT: 'OV_HEAT_TREAT',
  OV_HEAT_TREAT_SPECIAL: 'OV_HEAT_TREAT_SPECIAL',
  OV_HEAT_TREAT_SPECIAL_COMMENTS: 'OV_HEAT_TREAT_SPECIAL_COMMENTS',
} as const;
